//
// CompositeVisual.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./CompositeMember";
import "../VisualElement";

var CompositeVisual = createModule("BIRD::CompositeVisual", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        members: [1],
        name: 7,
        label: 7,
        type: 7,
    },
    ,
    ,
    {
        getPrimaryMember: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default CompositeVisual;
